import React from "react";

const STATS = [
  { value: "10,000+", label: "Ideas Envisioned" },
  { value: "2,500+", label: "Prototypes Targeted" },
  { value: "500+", label: "Facility Centres" },
  { value: "100+", label: "Patent Pathways" },
];

const CHAIN_ITEMS = [
  { icon: "trend", text: "When innovation moves faster, industries grow faster." },
  { icon: "factory", text: "When industries grow, manufacturing expands." },
  { icon: "people", text: "When manufacturing expands, jobs are created." },
  { icon: "target", text: "When products are built locally, dependency on imports can reduce." },
  { icon: "gauge", text: "When Indian products reach global markets, the entire economy benefits." },
];

const iconProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "white",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Icons = {
  trend: (
    <svg {...iconProps}>
      <path d="M3 17l5-5 4 4 8-8" />
      <path d="M15 8h5v5" />
    </svg>
  ),
  factory: (
    <svg {...iconProps}>
      <path d="M3 21V10l6 4v-4l6 4v-4l6 4v7H3z" />
      <path d="M6 21v-3M11 21v-3M16 21v-3" />
    </svg>
  ),
  people: (
    <svg {...iconProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
      <circle cx="17.5" cy="9.5" r="2.2" />
      <path d="M16 21v-1.5a3 3 0 0 0-1-2.2" />
    </svg>
  ),
  target: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="1" fill="white" stroke="none" />
    </svg>
  ),
  gauge: (
    <svg {...iconProps}>
      <path d="M4 15a8 8 0 1 1 16 0" />
      <path d="M12 15l3-4" />
      <circle cx="12" cy="15" r="1" fill="white" stroke="none" />
    </svg>
  ),
};

function StatCard({ value, label }) {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.14)",
        borderRadius: "16px",
        padding: "22px 26px",
        backdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          fontSize: "34px",
          fontWeight: 800,
          color: "white",
          lineHeight: 1.1,
          marginBottom: "8px",
        }}
      >
        {value}
      </div>
      <div style={{ fontSize: "14.5px", color: "#E5EAF1", fontWeight: 500 }}>
        {label}
      </div>
    </div>
  );
}

export default function ImpactSection() {
  return (
    <section
      style={{
        position: "relative",
        minHeight: "620px",
        padding: "72px 24px",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        backgroundImage:
          "url('https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=1800&auto=format&fit=crop')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      {/* Dark gradient overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(100deg, rgba(6,15,30,0.92) 0%, rgba(8,20,38,0.85) 40%, rgba(8,20,38,0.55) 75%, rgba(8,20,38,0.35) 100%)",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <span
          style={{
            display: "inline-block",
            fontSize: "13px",
            fontWeight: 700,
            letterSpacing: "1.5px",
            color: "white",
            marginBottom: "16px",
            textTransform: "uppercase",
          }}
        >
          Impact on Andhra Pradesh
        </span>

        <h2
          style={{
            fontSize: "42px",
            fontWeight: 800,
            color: "#FFFFFF",
            margin: "0 0 40px 0",
            lineHeight: 1.25,
            maxWidth: "760px",
          }}
        >
          Building a Stronger Andhra Pradesh Through{" "}
          <span style={{ color: "white" }}>Innovation.</span>
        </h2>

        {/* Stats */}
        <div
          className="impact-stats"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "18px",
            marginBottom: "44px",
            maxWidth: "980px",
          }}
        >
          {STATS.map((s) => (
            <StatCard key={s.label} value={s.value} label={s.label} />
          ))}
        </div>

        {/* Bottom row: list + quote box */}
        <div
          className="impact-bottom"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "40px",
            alignItems: "center",
          }}
        >
          <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
            {CHAIN_ITEMS.map((item) => (
              <li
                key={item.text}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  marginBottom: "14px",
                }}
              >
                <span style={{ marginTop: "2px", flexShrink: 0 }}>
                  {Icons[item.icon]}
                </span>
                <span
                  style={{
                    fontSize: "15.5px",
                    color: "#DCE3EC",
                    lineHeight: 1.5,
                  }}
                >
                  {item.text}
                </span>
              </li>
            ))}
          </ul>

          <div
            style={{
              background: "white",
              borderRadius: "18px",
              padding: "32px 36px",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: 800,
                color: "#0B1F3A",
                lineHeight: 1.35,
              }}
            >
              The innovation of one person can become the employment of
              thousands.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .impact-stats {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .impact-bottom {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 560px) {
          .impact-stats {
            grid-template-columns: 1fr 1fr !important;
          }
          h2 {
            font-size: 30px !important;
          }
        }
      `}</style>
    </section>
  );
}